// Diferencia o leitor de código de barras (modo teclado) de alguém digitando.
// O leitor manda o código inteiro em poucos milissegundos por tecla; uma pessoa
// leva bem mais. Usado pela faixa de leitura para recusar código digitado à mão.

/** Intervalo médio entre teclas acima do qual a leitura é considerada digitação. */
export const LIMITE_MEDIO_MS = 50;
/** Uma pausa longa no meio do código também denuncia digitação. */
export const LIMITE_PAUSA_MS = 250;

/**
 * Recebe os instantes (ms) de cada tecla de caractere do código. Devolve true se
 * parece leitor. Menos de 2 teclas registradas (código injetado de uma vez pela
 * coletora) conta como leitor.
 */
export function pareceLeitor(instantes: number[]): boolean {
  if (instantes.length < 2) return true;
  const intervalos = instantes.slice(1).map((t, i) => t - instantes[i]);
  const medio = intervalos.reduce((s, x) => s + x, 0) / intervalos.length;
  return medio <= LIMITE_MEDIO_MS && Math.max(...intervalos) <= LIMITE_PAUSA_MS;
}
